import {
  COMPLETE_FORM,
  GET_FORMS,
  GET_FORMS_COMPLETED,
  GET_FORMS_FAILED,
  MARK_FORMS,
  MARK_FORMS_COMPLETED,
  MARK_FORMS_FAILED,
} from '../../actions/form/types';
import { GetFormsQuery } from '../../graphql/API';
import { Action } from '../../utils/redux';

type FormData = GetFormsQuery['getForms']['items'];

type ReducerActions =
  | Action<
      typeof COMPLETE_FORM,
      {
        id: string;
      }
    >
  | Action<typeof GET_FORMS>
  | Action<typeof GET_FORMS_COMPLETED, FormData>
  | Action<typeof GET_FORMS_FAILED, Error>
  | Action<typeof MARK_FORMS>
  | Action<typeof MARK_FORMS_COMPLETED>
  | Action<typeof MARK_FORMS_FAILED>;

export interface FormState {
  forms: {
    data: FormData;
    error: null;
    loading: boolean;
  };
}

const initialState: FormState = {
  forms: {
    data: [],
    error: null,
    loading: false,
  },
};

function reducer(state = initialState, action: ReducerActions) {
  switch (action.type) {
    case COMPLETE_FORM:
      return {
        ...state,
        forms: {
          ...state.forms,
          data: state.forms.data.map((item) => {
            if (item.id === action.payload.id) {
              return {
                ...item,
                completed: true,
              };
            }

            return item;
          }),
        },
      };
    case GET_FORMS:
      return {
        ...state,
        forms: {
          ...state.forms,
          error: null,
          loading: true,
        },
      };
    case GET_FORMS_COMPLETED:
      return {
        ...state,
        forms: {
          ...state.forms,
          data: action.payload,
          loading: false,
        },
      };
    case GET_FORMS_FAILED:
      return {
        ...state,
        forms: {
          ...state.forms,
          error: action.payload,
          loading: false,
        },
      };
    case MARK_FORMS_COMPLETED:
      return {
        ...state,
        forms: {
          ...state.forms,
          data: state.forms.data.map(({ reminderCount, ...rest }) => ({
            ...rest,
            reminderCount: reminderCount + 1,
          })),
        },
      };
    default:
      return state;
  }
}

export default reducer;
